export var jobsTheme = {
    color: {
        background: '#eee',
        primary: '#324ECF',
        secondary: '#ebedfa',
        danger: '#FF3D00',
        accent: '#62727A',
        success: '#4CAF50',
    },
    fontFamily: 'Poppins',
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#333333',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#666666',
        },
        labels: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#666666',
        },
    },
    filterCard: {
        backgroundColor: '#FFFFFF',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
    },
    card: {
        backgroundColor: '#FFFFFF',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111a45',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111a45',
        },
        jobTypeStatus: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#fff0cc',
        },
        dayChip: {
            fontSize: '10px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#d7f2e3',
        },
    },
    noOfJobCardsPerRow: 3,
};
export var jdTheme = {
    color: {
        background: '#eee',
        primary: '#324ECF',
        secondary: '#ebedfa',
        danger: '#FF3D00',
        accent: '#62727A',
        success: '#4CAF50',
    },
    fontFamily: 'Poppins',
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#333333',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#666666',
        },
        labels: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#666666',
        },
    },
    card: {
        backgroundColor: '#FFFFFF',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
        backgroundColorSmall: '#e8ebf9',
        colorSmall: '#8e95aa',
        fontSizeSmall: '12px',
        fontWeightSmall: '400 ',
        borderColorSmall: '#CCCCCC',
        borderWidthSmall: '1px',
        boxShadowSmall: '0px 2px 4px #1A1A1A1A',
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111a45',
            fontSizeSmall: '14px',
            fontWeightSmall: '600',
            colorSmall: '#111a45',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111a45',
            fontSizeSmall: '10px',
            fontWeightSmall: '400',
            colorSmall: '#111a45',
        },
        jobTypeStatus: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#fff0cc',
            fontSizeSmall: '8px',
            fontWeightSmall: '300',
            colorSmall: '#111a45',
            backgroundColorSmall: '#fff0cc',
        },
        dayChip: {
            fontSize: '10px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#d7f2e3',
            fontSizeSmall: '12px',
            fontWeightSmall: '400',
            colorSmall: '#8e95aa',
            backgroundColorSmall: '#00000000',
        },
    },
};
export var myJobsTheme = {
    color: {
        background: '#eee',
        primary: '#324ECF',
        secondary: '#ebedfa',
        danger: '#FF3D00',
        accent: '#62727A',
        success: '#4CAF50',
    },
    fontFamily: 'Poppins',
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#333333',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#666666',
        },
        labels: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#666666',
        },
    },
    card: {
        backgroundColor: '#FFFFFF',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111a45',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111a45',
        },
        jobTypeStatus: {
            fontSize: '12px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#fff0cc',
        },
        dayChip: {
            fontSize: '10px',
            fontWeight: '400',
            color: '#111a45',
            backgroundColor: '#d7f2e3',
        },
    },
    noOfJobCardsPerRow: 3,
};
